import { useContext, useEffect, useState } from 'react';
import GlobalConfig from '../context/GlobalConfig';
import { languageData } from '../constants/languageData';

const Footer = ({ style = {} }) => {
    const { config } = useContext(GlobalConfig) ?? {};
    const language = sessionStorage.getItem("language") ?? "en";

    // Effective journey branding (Flow▸Team▸Org▸Signzy default), resolved by
    // one-journey-backend onto config.branding — the SAME source the header logo
    // uses, so they match, and companyLogo is always a real URL (never hardcoded in
    // the frontend). On terminal pages (session timed out / terminated) the flow
    // isn't loaded, so fall back to the cached sessionStorage("branding").
    let branding = config?.branding;
    if (!branding) {
        try {
            const stored = sessionStorage.getItem("branding");
            if (stored) branding = JSON.parse(stored);
        } catch (error) {
            branding = undefined;
        }
    }

    const poweredBy = languageData[language]?.poweredBy || 'Powered By';
    const logoUrl = branding?.companyLogo;

    // Track logo load failure so a broken/expired logo doesn't leave a broken image.
    // Reset when the URL changes.
    const [logoFailed, setLogoFailed] = useState(false);
    useEffect(() => { setLogoFailed(false); }, [logoUrl]);
    const showPartnerLogo = Boolean(logoUrl) && !logoFailed;

    // Clean slate: with no logo there is no footer branding at all — no "Powered By"
    // label, no text. The label and the logo only ever render together.
    if (!showPartnerLogo) return null;

    return (
        <div data-testid="footer" className="md:relative bottom-0 left-0 md:left-relative md:bottom-relative border-t w-full pt-2 flex flex-row gap-2 justify-center items-end text-[#929292] mt-[1rem] bg-white" style={{...style, minHeight:28}}>
            <div className="text-[10px] font-semibold font-sans">{poweredBy}</div>
            <img
                src={logoUrl}
                alt="Powered by"
                decoding="async"
                // Bound both dimensions so an oversized/wide partner logo can't
                // overflow the centered footer on mobile (PRD Problem 5).
                className="h-5 max-w-[120px] object-contain"
                onError={() => setLogoFailed(true)}
            />
        </div>
    )
}

export default Footer;
